<script setup>
import { computed, ref, onMounted } from 'vue'
import '../assets/styles/sanitize.css'
import '../assets/styles/app.css'
import SectionTitle from './SectionTitle.vue'
import News from './News.vue'
import { useCommon } from '../composable/useCommon.js'
import { useGetData } from '../composable/useGetData.js'
const { isWebView } = useCommon()
const { getNewsList } = useGetData()
const topicsList = ref(['', '', ''])
const isError = ref(false)

const props = defineProps({
  appViewShow: {
    type: Boolean,
    default: true
  },
  isWebViewProp: {
    type: Boolean,
    default: false
  },
  listLength: {
    type: Number,
    default: 3
  },
  isWrap: {
    type: Boolean,
    default: false,
    required: false
  },
  ignoreTpid: {
    type: String,
    default: '',
    required: false
  }
})

const isWebViewFlag = ref(props.isWebViewProp)

const getNews = async () => {
  try {
    topicsList.value = await getNewsList()
  } catch (error) {
    isError.value = true
  }
}

const filteredTopicsList = computed(() => {
  return topicsList.value
    .filter(item => item.tpid !== props.ignoreTpid)
    .slice(0, props.listLength)
})
onMounted(() => {
  isWebViewFlag.value = isWebView()
  getNews()
})
</script>

<template>
  <section
    v-if="(!isWebViewFlag || appViewShow) && !isError"
    class="newslist"
  >
    <SectionTitle
      title="お天気ニュース"
      button-text="もっと読む"
      button-dir="left"
      button-col="white"
      button-link="https://weathernews.jp/s/topics/"
    />
    <ul
      :data-wrap="isWrap"
      class="content"
    >
      <li
        v-for="content in filteredTopicsList"
        :key="content.id"
        :data-wrap="isWrap"
        class="list"
      >
        <News
          :img="content.thumb_img"
          :url="content.url"
          :title="content.title"
          :date="content.edit_tstr"
        />
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.newslist {
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }
  .list {
    border-bottom: solid 1px #dfe4f0;
    &:first-child {
      border-top: solid 1px #dfe4f0;
    }
  }
}
main {
  .newslist {
    @media screen and (min-width: 830px) {
      .content {
        flex-direction: row;
        gap: 10px;
        &[data-wrap="true"] {
          flex-wrap: wrap;
        }
      }
      .list {
        flex: 1;
        border: solid 1px #dfe4f0;
        border-radius: 8px;
        overflow: hidden;
        &:is([data-wrap="true"] *) {
          flex: auto;
          width: calc((100% - 20px) / 3);
        }
      }
    }
  }
}
</style>
